/**
 * Header-element reorder adapter.
 *
 * Registers runtime-marked header flex-zone children as direct drag-reorder
 * sources. It does not participate in context-menu matching.
 */

import { moveHeaderSiblingByEid } from '../element-insert.js';

const REORDER_EXCLUDE_TAIL =
  ':not([aria-hidden="true"])' +
  ':not(.cs-ul-bg)' +
  ':not(.background-color-div)' +
  ':not(style):not(script):not(template):not(meta):not(link)';

export const headerElementAdapter = {
  kind: 'header-element',
  label: 'Header element',
  itemSelector: '[data-pb-reorder-zone] > *',
  parentSelector: null,
  reorderSelector: '[data-pb-reorder-zone] > *' + REORDER_EXCLUDE_TAIL,
  reorderSiblingSelector: '[data-pb-reorder-zone] > *' + REORDER_EXCLUDE_TAIL,
  // A pointer inside a nav list belongs to the nav-link adapter, not the
  // header-element zone; reject so grabbing a nav link doesn't drag the whole
  // header flex-zone child.
  rejectIfTargetClosest: 'ul.cs-ul, ul.cs-drop-ul',
  // Reorder contract (Phase 1). vtSelector intentionally OMITS the exclude tail
  // that reorderSiblingSelector carries — it mirrors the pre-refactor
  // VT_CONFIG_BY_LABEL selector so view-transition naming stays byte-identical.
  reorderAxis: 'x',
  historyLabel: 'Reorder header element',
  toastText: 'Header element reordered',
  vtPrefix: 'pb-hdr-',
  vtSelector: '[data-pb-reorder-zone] > *',
  moveFn: moveHeaderSiblingByEid,
  menuActions: [],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match() {
    return null;
  }
};
